// extracted by mini-css-extract-plugin
export default {"header":"PageHeader__header___3gt2B"};